import { Link } from 'react-router-dom'
import type { TaskContext } from '../types'

interface ContextLinkProps {
  context: TaskContext
  /** Gdy true (default false), klik propaguje stopPropagation - przydatne wewnątrz
   *  klikalnej karty (KanbanCard ma onClick otwierający drawer; ten link ma nawigować
   *  do umowy bez otwierania drawera). */
  stopPropagation?: boolean
  className?: string
}

/**
 * Renderuje label kontekstu jako klikalny link gdy znamy ścieżkę dla danego typu.
 *  - EASY/CONTRACT → /contracts/{id}
 *  - inne (HALO/LEAD, HALO/MEETING) → plain span (brak route w easycrm)
 *
 * Frontend agnostyczny względem schematu HALO - jeśli kiedyś będziemy mieli proxy do
 * leadów lub jest Halo embed, dodajemy tu kolejny case.
 */
export function ContextLink({ context, stopPropagation = false, className }: ContextLinkProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (stopPropagation) e.stopPropagation()
  }

  if (context.system === 'EASY' && context.type === 'CONTRACT') {
    return (
      <Link
        to={`/contracts/${context.id}`}
        onClick={handleClick}
        className={`text-sky-600 hover:underline ${className ?? ''}`}
      >
        {context.label}
      </Link>
    )
  }
  // Unknown context system+type → not navigable in EasyCRM (yet).
  return <span className={className}>{context.label}</span>
}
